module.exports = __webpack_public_path__ + "media/svg/home-outline-24cc84d3.svg";